<template>
  <div>
    <van-popup
      v-model:show="infoSubmit"
      round
      :style="{ width: '80%' }"
    >
        <div class="formMain">
          <p>为了保证您的考试正常进行和资格证书领取请您完善以下信息</p>
          <div class="form">
            <div class="line">
              <p>姓名</p>
              <span>:</span>
              <div><input v-model="form.name" placeholder="请输入您的姓名" /></div>
            </div>
            <div class="line">
              <p>性别</p>
              <span>:</span>
              <div>
                <p @click="form.gender = 1" :class="{ sexActive: form.gender == 1 }">
                  <img :src="form.gender == 1 ? radio2 : radio" />男
                </p>
                <p @click="form.gender = 2" :class="{ sexActive: form.gender == 2 }">
                  <img :src="form.gender == 2 ? radio2 : radio" />女
                </p>
              </div>
            </div>
            <div class="line">
              <p>手机号</p>
              <span>:</span>
              <div>{{ form.mobile }}</div>
            </div>
            <div class="line">
              <p>身份证号</p>
              <span>:</span>
              <div><input v-model="form.cid" placeholder="请输入您的身份证号" /></div>
            </div>
            <div class="img">
              <img :src="form.cover || formImg" />
              <input type="file" accept=".png, .jpg, .jpeg" @change="uploadData" />
            </div>
          </div>

          <div class="btn" @click="formSubmit">确认并保存</div>
        </div>
    </van-popup>
    
    <div class="listBtn" v-if="list">
      <p v-if="testInfo.test_time && testInfo.test_status == 0" @click="toExamin" class="red">未通过/重考</p>
      <p v-if="testInfo.test_time && testInfo.test_status == 1" @click="toExamin" class="green">考试通过</p>
      <p v-if="!testInfo.test_time" @click="toExamin" class="yellow">课程考试</p>
    </div>
    <div class="examin-content" v-else  @click="toExamin">
      <div class="examinTitle">{{ testInfo && testInfo.name }}考试试题</div>
      <div class="examinDesc">
        <p>满分{{ testInfo && testInfo.score }}分 试题{{
          testInfo.question_num
        }}道 {{ testInfo && testInfo.pass }}分及以上为合格
        </p>
        <p v-if="testInfo.test_time">
         考试时间：{{ testInfo.test_time }}
        </p>
      </div>
      <div class="examinBtn" v-if="testInfo.test_time && testInfo.test_status == 0">
        <p class="red" >不合格</p>
        <div class="btn">
          <p class="yellow">重新考试</p>
        </div>
      </div>
      <div class="examinBtn" v-if="testInfo.test_time && testInfo.test_status == 1">
        <p class="green" >合格</p>
        <div class="btn">
          <p>查看试卷</p>
        </div>
      </div>
      <div class="examinBtn" v-if="!testInfo.test_time">
        <p> 未考试</p>
        <div class="btn">
          <p class="yellow">开始考试</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["testInfo", "list"],
  data() {
    return {
      form: {
        gender: 2,
        name: "",
        mobile: this.$store.state.user.mobile,
        cid: "",
        cover: "",
      },
      formImg:
        "https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/tuoyu2/formImg.jpg",
      radio:
        "https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/tuoyu2/formRadio.jpg",
      radio2:
        "https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/tuoyu2/formRadio2.jpg",
      infoSubmit: false,
      // testInfo:{
      //   exam_pass: 0,
      //   name:'试卷题目',
      //   score: 100,
      //   question_number: 10,
      //   pass: 0,
      //   exam_time: '2022-10-10 12:12:12'
      // },
      pass:
        "https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/tuoyu2/pass.jpg",
      noPass:
        "https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/tuoyu2/noPass.jpg",
    };
  },
  computed: {
    vipInfo() {
      return this.$store.state.vipInfo;
    },
    platName() {
      return this.$store.state.plat.name;
    },
    plat() {
      return this.$store.state.plat_id;
    },
    VIPShow() {
      return this.$store.state.VIPShow;
    },
    logo() {
      return this.$store.state.plat.logo;
      // return "https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/tuoyulogo.png";
    },
  },
  inject: ['baseInfo'],
  mounted() {},
  methods: {
    uploadData(e) {
      console.log(e.target.files[0]);
      let file = e.target.files[0];
      // file.size < 1024 * 200 ||
      if (file.size > 1024 * 1024) {
        this.$toast("请上传符合要求的照片");
        return;
      }
      let param = new FormData();
      param.append("folder", file);
      this.$request.toUpload(param).then((res) => {
        if (res.code == 0) {
          this.form.cover = res.data.fullpath;
        } else {
          this.$toast(res.msg);
        }
      });
    },
    formSubmit() {
      // if(this.$until.checkPhone(this.form.mobile)!='ok'){
      //   this.$toast(this.$until.checkPhone(this.form.mobile));
      //   return
      // }
      if(this.$until.checkCard(this.form.cid)!='ok'){
        this.$toast(this.$until.checkCard(this.form.cid));
        return
      }
      if (Object.values(this.form).findIndex((item) => !item) != -1) {
        this.$toast("请补全全部信息");
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$request.userInfoSubmit(this.form).then((res) => {
        loading.close();
        if (res.code == 0) {
          this.$router.push({
            path: "./examinList",
            query: {
              id: this.testInfo.id,
              isExamin: true,
            },
          });
        } else {
          this.$toast(res.msg);
        }
      });
    },
    toExamin() {
      let isStudy = this.list
        ? this.list.every((item) => item.study_status == 1)
        : this.testInfo.is_test;
      let baseInfo = this.baseInfo() || this.$parent.baseInfo || this.$parent.$parent.baseInfo;
      console.log(baseInfo)
      // if (!isStudy) {
      if (!isStudy) {
        this.$toast("您的课程还没有全部学习完成，请学习完全部课程后在参加考试");
        return;
      }
      
      if (!baseInfo.test_message && baseInfo.category_id!=225) {
        this.infoSubmit = true;
        return;
      }
      if (this.testInfo.test_time && this.testInfo.test_status == 1) {
        this.$router.push({
          path: "./examinList",
          query: {
            currentIndex: 0,
            id: this.testInfo.id,
            resultId: this.testInfo.report_id,
            discipline_id: baseInfo.discipline_id
          },
        });
      } else {
        this.$router.push({
          path: "./examinList",
          query: {
            id: this.testInfo.id,
            isExamin: true,
            discipline_id: baseInfo.discipline_id
          },
        });
      }

      // } else {
      //   this.$toast("您还未满足考试要求");
      // }
    },
    toPage() {
      if (!localStorage.getItem("user")) {
        this.$store.commit("changeLoginShow", true);
      } else {
        this.$router.push({
          path: "./detailVip",
          query: {
            id: this.vipInfo.goods_id,
          },
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.green{
  color: #3BD322 !important;
}
.red{
  color: #F33B2E !important;
}
.yellow{
  color: #F08E00 !important;
}
.listBtn{
  p{
    height: 80px;
    background: #FFFFFF;
    border-radius: 40px;
    line-height: 80px;
    text-align: center;
    font-size: 28px;
    font-weight: 500;
    margin: 32px 24px;
  }
}
.formMain {
  color: #333333;
  overflow: hidden;
  padding-bottom: 40px;
  > p {
    padding: 40px 30px;
    text-align: center;
    font-size: 28px;
  }
  .form {
    .line {
      display: flex;
      align-items: center;
      width: 100%;
      height: 80px;
      padding: 0 30px;
      box-sizing: border-box;
      > p {
        font-size: 24px;
        width: 100px;
        text-align: justify;
        text-align-last: justify;
        margin-right: 6px;
      }
      > span {
        font-size: 16px;
      }
      > div {
        margin-left: 11px;
        padding-left: 10px;
        flex: 1;
        border-bottom: 1px solid #e4e8ed;
        line-height: 60px;
        height: 64px;
        display: flex;
        align-items: center;
        input {
          border: 0;
          height: 60px;
          background: transparent;
        }
        p {
          width: 79px;
          display: flex;
          align-items: center;
          color: #999999;
          cursor: pointer;
          img {
            margin-right: 8px;
          }
        }
        p.sexActive {
          color: #666;
        }
      }
    }
    .img {
      margin: 10px auto 0;
      width: 248px;
      height: 346px;
      position: relative;
      input {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
      }
    }
  }

  .btn {
    width: 80%;
    height: 72px;
    cursor: pointer;
    margin: 20px auto 0;
    background: #0080d6;
    color: #fff;
    font-size: 28px;
    line-height: 72px;
    text-align: center;
    border-radius: 36px;
  }
}
.examin-content {
  width: calc(100vw - 64px);
  margin: 0 auto 20px;
  background: #F7F7F7;
  border-radius: 12px;
  overflow: hidden;
  padding: 32px 24px;
  font-size: 14px;
  box-sizing: border-box;
  color: #000000;
}
.examin-content .examinBtn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-top: 8px;
  >p{
    font-size: 28px;
    font-weight: 500;
    color: #666666;
  }
  .btn {
    width: 160px;
    height: 64px;
    line-height: 64px;
    background: #FFFFFF;
    border-radius: 32px;
    text-align: center;
    font-size: 24px;
    font-weight: 500;
    color: #000000;
  }
}

.examin-content  .examinTitle {
  color: #000;
  width: 100%;
  font-size: 28px;
  margin-bottom: 8px;
  font-weight: 500;
  padding: 0;
}
.examin-content  .examinDesc {
  font-size: 20px;
  font-weight: 400;
  color: #999999;
  padding-bottom: 8px;
  line-height: 40px;
}
</style>
